import { useTheme } from "next-themes";
import { Toaster } from "sonner";

export function ThemedToaster() {
  const { resolvedTheme } = useTheme();
  return (
    <Toaster
      position="top-right"
      richColors
      closeButton
      expand
      theme={(resolvedTheme as "light" | "dark") ?? "system"}
    />
  );
}
